import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { ANY_SPORT_PLAY_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

const FullWidthHorizontal = styled(Horizontal)`
  width: 100%;
  flex-wrap: wrap;
`;

type Props = {
  so5FixtureSlug?: string;
  eventType?: So5FixtureEvent;
  onNext?: () => void;
  onClose: () => Promise<void>;
};
export const Cta = ({ so5FixtureSlug, eventType, onNext, onClose }: Props) => {
  const navigate = useNavigate();
  const { generateSportContextPath } = useSportContext();

  return onNext ? (
    <Button size="medium" color="secondary" fullWidth onClick={onNext}>
      <FormattedMessage {...glossary.next} />
    </Button>
  ) : (
    <FullWidthHorizontal center>
      {so5FixtureSlug && (
        <Button
          size="medium"
          color="primary"
          fullWidth
          onClick={async () => {
            navigate(
              generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE, {
                params: {
                  eventType: eventType?.toLowerCase() || '',
                  fixture: so5FixtureSlug,
                },
              })
            );
            await onClose?.();
          }}
        >
          <FormattedMessage
            id="LastFixtureStory.Cta.checkResults"
            defaultMessage="Check my results"
          />
        </Button>
      )}
      <Button size="medium" color="secondary" fullWidth onClick={onClose}>
        <FormattedMessage {...glossary.close} />
      </Button>
    </FullWidthHorizontal>
  );
};
